import { Component, ElementRef, input, OnInit } from '@angular/core';
import { DatePickerModule } from 'primeng/datepicker';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-form-date-picker',
    standalone: true,
    imports: [ReactiveFormsModule, DatePickerModule],
    templateUrl: './form-date-picker.html',
    styleUrl: './form-date-picker.scss',
    host: {
        class: 'min-w-[125px] flex-grow flex-1 md:max-w-[400px]'
    }
})
export class FormDatePicker implements OnInit {
    id = input<string>('');
    label = input<string>('');
    customClass = input<string>('');
    control = input<AbstractControl<any, any, any> | null>();

    constructor(private elementRef: ElementRef<HTMLElement>) {}

    ngOnInit() {
        if (this.customClass()) {
            this.applyStyleClass();
        }
    }

    applyStyleClass(): void {
        const element = this.elementRef.nativeElement;
        const cClass = this.customClass().trim();
        if (element && cClass) {
            element.classList = cClass;
        }
    }
}
